module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgB7ZXhCYAgEIWvaIBGyA0aoY1qg0ZohjZpk9qgNrjuoCBE8TQlCD+4H8o7H54nB/B7ELGn2NENa0YIgRJb9KeWnF1q6ztpKRyQZtNyvIySYTXiklCshlKtENMoNlYjeoaDQhmeR2lS060nsdHL0g2k60RGHiitG+drv3mKKls2l44PgUh83wzZKBulhX5xg7JhF0L3vBHPlAPSIJpXGSsnjVwWfeP0ZyQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Building_04.png
// module id = kIGA
// module chunks = 1